// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { getOperationResult, getOperationStatus } from "./operations.js";
export type {
  GetOperationResultOptionalParams,
  GetOperationStatusOptionalParams,
} from "./options.js";
export type {
  RecoveryServicesContext,
  RecoveryServicesClientOptionalParams,
} from "./recoveryServicesContext.js";
export { createRecoveryServices } from "./recoveryServicesContext.js";
